module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Privacy",
	"footer.privacy.url": "https://www.grohe.ru/ru_ru/kompanija/novosti/bezopasnost.html",
	"footer.disclaimer.text": "Legal Info",
	"footer.disclaimer.url": "https://www.grohe.ru/ru_ru/kompanija/novosti/juridicheskaja-infomracija.html",
	"footer.copyright": "&copy; 2018 GROHE AG",
	"homepage.headline": "Конфигуратор GROHE SmartControl",
	"homepage.introtext": "Найдите самую подходящую для вас душевую систему GROHE SmartControl. Идеальный душ прямо здесь в вашем распоряжении.",
	"homepage.buttonStart": "Начать",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 Page Not Found",
	"404.link.goBack": "Go back to homepage",
	"configurator.button.seeResults": "Смотреть результат",
	"question1.question": "Где вы хотите разместить душ? ",
	"question1.option1.text": "В выделенном пространстве для душа",
	"question1.option2.text": "В ванной для купания, включая излив в ванну",
	"question2.question": "Какой вид монтажа вы предпочитаете? Внешний, Скрытый или их комбинацию?",
	"question2.option1.text": "Внешний монтаж: простой и легкий вариант с установкой перед стеной для модификации вашего существующего душа",
	"question2.option2.text": "Комбинированный монтаж: подводка скрыта внутри стены, а термостат с полочкой расположены перед стеной",
	"question2.option3.text": "Скрытый монтаж: минималистичный утонченный дизайн, когда все коммуникации скрыты внутри стены",
	"question3.question": "Как вы предпочитаете управлять вашим душем?",
	"question3.option1.text": "С помощью системы SmartControl (интеллектуальное управление) и Термостата (современный смеситель с функцией поддержания постоянной температуры)",
	"question3.option2.text": "Посредством обычных действий и термостата",
	"question3.option3.text": "С помощью однорычажного смесителя",
	"question3.option4.text": "С помощью переключателя для настенного монтажа (сохраняя существующий смеситель)",
	"question4.question": "Какими элементами вам бы хотелось управлять с помощью вашего Душа?",
	"question4.option1.text": "Только ручной душ",
	"question4.option2.text": "Большой верхний душ (150-200 мм) и ручной душ",
	"question4.option3.text": "Сверхбольшой верхний душ (250-400 мм) и ручной душ",
	"question4.option4.text": "Большой верхний душ (150-200 мм), ручной душ и излив для ванны",
	"question4.option5.text": "Сверхбольшой верхний душ (250-400 мм), ручной душ и излив для ванны",
	"question5.question": "Какую форму вы предпочитаете?",
	"question5.option1.text": "Квадратная форма",
	"question5.option2.text": "Округлая форма",
	"question6.question": "Что бы вам хотелось контролировать посредством вашей новой системы SmartControl?",
	"question6.option1.text": "Верхний душ с 2 режимами струи и ручной душ",
	"question6.option2.text": "Верхний душ с 2 режимами струи и ручной душ",
	"question6.option3.text": "Верхний душ, ручной душ и излив для ванны",
	"question6.option4.text": "Верхний душ, два боковых душа и ручной душ",
	"question6.option5.text": "Ручной душ и излив для ванны",
	"question6.option6.text": "Ручной душ и излив для ванны",
	"question6.option7.text": "Только ручной душ",
	"question6.option8.text": "Только излив для ванны",
	"question7.question": "Выберите цвет",
	"question7.option1.text": "Хром",
	"question7.option2.text": "Белый/Хром",
	"question7.option3.text": "Белый/Хром",
	"question8.question": "Вам бы хотелось термостат со встроенным держателем для ручного душа?",
	"question8.option1.text": "Да, со встроенным держателем для ручного душа",
	"question8.option2.text": "Нет, я куплю отдельный держатель для ручного душа",
	"question9.question": "Какой способ крепления для ручного душа вы бы предпочли?",
	"question9.option1.text": "На душевую штангу с возможностью регулировки высоты фиксации душа",
	"question9.option2.text": "На минималистичный душевой держатель",
	"question10.question": "Вы бы хотели установить ваш верхний душ на стену или на потолок?",
	"question10.option1.text": "Верхний душ, установленный на стену",
	"question10.option2.text": "Верхний душ, установленный на потолок",
	"results.title": "Ваш результат",
	"results.proposal.title": "предложение {number}",
	"results.proposal.title.single": "предложение",
	"results.bundle.title": "Для правильной установки вам также потребуется:",
	"results.newConfiguration.title": "Вы хотите подобрать другую душевую систему?",
	"results.newConfiguration.buttonText": "Начать подбор заново",
	"results.product.number": "Артикул товара: #{number}",
	"results.product.button.productInformation": "Информация о товаре",
	"results.product.button.dealerLocator": "Найти магазин",
	"results.product.button.buyNow": "Купить онлайн",
	"results.product.button.downloadPDF": "Скачать PDF",
	"results.product.information": "Информация о товаре",
	"results.product.dealer": "Найти магазин",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now"
};


//////////////////
// WEBPACK FOOTER
// ./src/translations/shower.ru_ru.json
// module id = 757
// module chunks = 0